"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7847],{

/***/ 77847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SectionRrss; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ./hooks/index.ts + 3 modules
var hooks = __webpack_require__(2722);
// EXTERNAL MODULE: ../commons/dist/utils/index.js
var utils = __webpack_require__(76079);
;// CONCATENATED MODULE: ./components/layout/layoutConfig.ts
var SOCIAL_LINKS = {
    "es-ES": {
        instagram: "https://www.instagram.com/mammafiore_official/",
        facebook: "https://www.facebook.com/mammafiore",
        linkedin: "https://es.linkedin.com/company/mammafiore",
        youtube: "https://www.youtube.com/@mammafiore_official",
        tiktok: "https://www.tiktok.com/@hellomamma_es"
    },
    "fr-FR": {
        instagram: "https://www.instagram.com/mammafiore_official/",
        facebook: "https://www.facebook.com/mammafiore",
        linkedin: "https://es.linkedin.com/company/mammafiore",
        youtube: "https://www.youtube.com/@mammafiore_official",
        tiktok: "https://www.tiktok.com/@hellomamma_fr"
    },
    "en-GB": {
        instagram: "https://www.instagram.com/mammafiore_official/",
        facebook: "https://www.facebook.com/mammafiore",
        linkedin: "https://es.linkedin.com/company/mammafiore",
        youtube: "https://www.youtube.com/@mammafiore_official",
        tiktok: "https://www.tiktok.com/@hellomamma_en"
    },
    "de-DE": {
        instagram: "https://www.instagram.com/mammafiore_official/",
        facebook: "https://www.facebook.com/mammafiore",
        linkedin: "https://es.linkedin.com/company/mammafiore",
        youtube: "https://www.youtube.com/@mammafiore_official",
        tiktok: "https://www.tiktok.com/@hellomamma_de"
    },
    "pt-PT": {
        instagram: "https://www.instagram.com/mammafiore_official/",
        facebook: "https://www.facebook.com/mammafiore",
        linkedin: "https://es.linkedin.com/company/mammafiore",
        youtube: "https://www.youtube.com/@mammafiore_official",
        tiktok: "https://www.tiktok.com/@hellomamma_pt"
    }
};
var FOOTER_URLS = {
    "es-ES": "/page/aviso-legal",
    "en-GB": "/page/legal-notice",
    "it-IT": "/page/avviso-legale",
    "fr-FR": "/page/mentions-legales",
    "de-DE": "/page/rechtlicher-hinweis",
    "pt-PT": "/page/aviso-legal"
};

// EXTERNAL MODULE: ../commons/dist/components/index.js
var components = __webpack_require__(17566);
// EXTERNAL MODULE: ../commons/dist/hooks/index.js
var dist_hooks = __webpack_require__(92757);
// EXTERNAL MODULE: ../commons/dist/context/index.js
var context = __webpack_require__(7693);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19453);
// EXTERNAL MODULE: ../commons/dist/styles/index.js
var styles = __webpack_require__(73267);
;// CONCATENATED MODULE: ./components/layout/footer/SectionRrss.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  grid-column: 1 / span 6;\n  padding: 0;\n  width: auto;\n\n  ",
        " {\n    align-items: flex-end;\n    grid-column: 1 / span 12;\n    grid-row: 3 / span 1;\n  }\n\n  .stamp {\n    grid-area: 2 / 1 / span 1 /span 3;\n    display: flex;\n    flex-direction: row;\n\n    ",
        " {\n      grid-area: unset;\n      grid-row: 1 / span 1;\n      grid-column: 2 / span 3;\n    }\n    figure {\n      margin-right: ",
        ";\n      width: ",
        ";\n      height: ",
        ";\n      ",
        " {\n        margin-right: ",
        ";\n        height: ",
        ";\n        width: ",
        ";\n      }\n      ",
        " {\n        margin-right: ",
        ";\n\n        height: ",
        ";\n        width: ",
        ";\n      }\n      ",
        " {\n        margin-right: 30px;\n        height: 100px;\n        width: 100px;\n      }\n    }\n\n    img {\n      color: ",
        ";\n      mix-blend-mode: multiply;\n      filter:invert(49%) sepia(37%) saturate(691%) hue-rotate(313deg) brightness(74%) contrast(27%);\n\n    }\n  }\n\n  .list--rrss {\n    align-self: flex-end;\n    grid-column: 4 / span 3;\n    grid-row: 2 / span 1;\n    display: flex;\n    list-style-type: none;\n    margin-bottom: ",
        ";\n    height: ",
        ";\n\n    ",
        " {\n      margin-bottom: ",
        ";\n      height: ",
        ";\n\n    }\n\n    ",
        " {\n      height: unset;\n      grid-column: 6 / span 3;\n      grid-row: 2 / span 1;\n      margin-bottom: 0;\n    }\n\n    li {\n      align-items: center;\n      display: flex;\n      margin-right: ",
        ";\n\n      ",
        " {\n        margin-right: ",
        ";\n      }\n\n      ",
        " {\n        margin-right: ",
        ";\n      }\n\n      ",
        " {\n        margin-right: 15px;\n      }\n\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n\n    a {\n      display: inline-block;\n      opacity: .4;\n      text-decoration: none;\n      transition: 300ms opacity ease-out;\n\n      &:hover {\n        opacity: 1;\n      }\n\n      figure {\n        height: ",
        ";\n        width: ",
        ";\n\n        ",
        " {\n          height: ",
        ";\n          width: ",
        ";\n        }\n\n        ",
        " {\n          height: ",
        ";\n          min-height: 30px;\n          min-width: 30px;\n          width: ",
        ";\n        }\n\n        ",
        " {\n          height: 30px;\n          width: 30px;\n        }\n      }\n    }\n  }\n\n  .row-copyright {\n    display: flex;\n    flex-direction: column;\n    grid-column: 1 / span 3;\n    grid-row: 3 / span 1;\n    margin-top: ",
        ";\n    ",
        " {\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      flex-direction: row;\n      grid-row: 2 / span 1;\n      grid-column: 2 / span 4;\n      margin-top: ",
        ";\n    }\n\n    ",
        " {\n      margin-top: 45px;\n    }\n\n    > a,\n    > span {\n      ",
        "\n      color: ",
        ";\n      margin-bottom: 0;\n    }\n\n    > span {\n      margin-bottom: ",
        ";\n      margin-right: 0;\n\n      ",
        " {\n        margin-bottom: ",
        ";\n      }\n\n      ",
        " {\n        margin-bottom: 0;\n        margin-right: ",
        ";\n      }\n\n      ",
        " {\n        margin-right: 30px;\n      }\n    }\n\n    > a {\n      transition: 300ms opacity ",
        ";\n      &:hover {\n        opacity: 1;\n      }\n    }\n  }\n\n  .btn--country-and-lang {\n    ",
        "\n    border-radius: ",
        ";\n    color: ",
        ";\n    height: ",
        ";\n    font-family: ",
        ";\n    margin: auto auto 0 0;\n    padding: 0 ",
        ";\n\n    ",
        " {\n      border-radius: ",
        ";\n      height: ",
        ";\n      padding: 0 ",
        ";\n    }\n\n    ",
        " {\n      border-radius: ",
        ";\n      height: ",
        ";\n      padding: 0  ",
        ";\n      letter-spacing: -0.5px;\n    }\n\n    ",
        " {\n      border-radius: 90px;\n      height: 40px;\n      padding: 0 20px;\n    }\n\n    .button__bg + div {\n      ",
        " {\n        white-space: break-spaces;\n      }\n    }\n  }\n\n  .row-partners {\n    grid-column: 1 / span 6;\n    grid-row: 1 / span 1;\n    align-items: flex-end;\n    margin-bottom: ",
        ";\n\n    ",
        " {\n      grid-column: 6 / span 3;\n      grid-row: 1 / span 1;\n      margin-bottom: 0;\n    }\n\n    > ul {\n      display: flex;\n      flex-direction: row;\n    }\n\n    span {\n      ",
        "\n      color: ",
        ";\n      display: block;\n      mix-blend-mode: multiply;\n      filter:invert(49%) sepia(37%) saturate(691%) hue-rotate(313deg) brightness(74%) contrast(27%);\n      margin: ",
        " 0 ",
        ";\n\n      ",
        " {\n        margin-bottom: ",
        ";\n      }\n    }\n\n    li:first-of-type,\n    li:nth-of-type(3) {\n      img {\n        width: ",
        ";\n\n        ",
        " {\n          width: ",
        ";\n        }\n      }\n    }\n\n    img {\n      height: ",
        ";\n      color: ",
        ";\n      filter:invert(49%) sepia(37%) saturate(691%) hue-rotate(313deg) brightness(74%) contrast(27%);\n      margin-right : ",
        ";\n      mix-blend-mode: multiply;\n      width: ",
        ";\n\n      ",
        " {\n        height: ",
        ";\n        margin-right : ",
        ";\n        width: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  grid-column: 4 / span 3;\n\n  ",
        " {\n    align-items: center;\n    flex-direction: row;\n    grid-column: 9 / span 3;\n    grid-row: 2 / span 1;\n  }\n\n  p {\n    ",
        "\n    color: ",
        ";\n    margin-bottom: 8px;\n\n    ",
        " {\n      margin-bottom: 0;\n      margin-right: 10px;\n    }\n\n    ",
        " {\n      margin-right: 16px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var mediaStamp = {
    type: "image",
    alt: "Stamp denominazione origine logo",
    default: {
        src: "/images/svg/i--stamp--denominazione-origine-protetta.svg",
        size: {
            width: 6,
            height: 8
        }
    }
};
var ecoStamp = {
    type: "image",
    alt: "Stamp evo certification",
    default: {
        src: "/images/svg/i--eco.svg",
        size: {
            width: 275,
            height: 183
        }
    }
};
var mozzarellaStamp = {
    type: "image",
    alt: "Stamp Mozzarella Bufala",
    default: {
        src: "/images/svg/i--mozzarella.svg",
        size: {
            width: 275,
            height: 183
        }
    }
};
var arrSocialNetworks = [
    "instagram",
    "facebook",
    "linkedin",
    "youtube"
];
var mediaSocialIcon = function(name) {
    return {
        type: "image",
        alt: "".concat(name, " logo"),
        default: {
            src: "/images/svg/i--rrss--".concat(name, ".svg"),
            size: {
                width: 30,
                height: 30
            }
        }
    };
};
var getSocialLinks = function(data, localeRegion) {
    return data.map(function(name) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: SOCIAL_LINKS[localeRegion][name],
                rel: "noreferrer",
                target: "_blank",
                title: name,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                    media: mediaSocialIcon(name)
                })
            })
        }, name);
    });
};
var LOGOS = [
    {
        "url": "/images/svg/logo-50-top.svg",
        "alt": "Logo 50 Top",
        "href": "/page/50-top-pizza "
    },
    {
        "url": "/images/svg/logo-ilif.svg",
        "alt": "Logo I Love Italian Food"
    },
    {
        "url": "/images/svg/logo-ffm.svg",
        "alt": "Logo 50 Top"
    }, 
];
var getFeaturedLogos = function() {
    return LOGOS.map(function(logo, idx) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            children: idx === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: logo === null || logo === void 0 ? void 0 : logo.href,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: logo === null || logo === void 0 ? void 0 : logo.url,
                    alt: logo === null || logo === void 0 ? void 0 : logo.alt
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: logo === null || logo === void 0 ? void 0 : logo.url,
                alt: logo === null || logo === void 0 ? void 0 : logo.alt
            })
        }, idx);
    });
};
/* harmony default export */ var SectionRrss = (/*#__PURE__*/(0,react.memo)(function() {
    var t = (0,hooks/* useTranslator */.I4)().t;
    var locale = (0,router.useRouter)().locale;
    var localeRegion = (0,react.useMemo)(function() {
        return (0,utils.getLocaleCountry)(locale);
    }, [
        locale
    ]);
    var ListItemsSocialLinks = (0,react.useMemo)(function() {
        return getSocialLinks(arrSocialNetworks, localeRegion);
    }, [
        localeRegion
    ]);
    var toggle = (0,dist_hooks.useModal)(context.MODALS.REGION_LANG).toggle;
    var FeaturedLogos = getFeaturedLogos();
    var ref = (0,react.useState)(""), location = ref[0], setLocation = ref[1];
    (0,react.useEffect)(function() {
        var cookieCatalogRegion = utils.cookie.get("DY_CATALOG_REGION");
        var countryCode = "ES";
        function getCurrentLocation() {
            return _getCurrentLocation.apply(this, arguments);
        }
        function _getCurrentLocation() {
            _getCurrentLocation = (0,_async_to_generator/* default */.Z)(function() {
                var ref, data, dataArr, incomingLocation;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                __webpack_require__(97820)("./".concat(countryCode, "-subdivisions.json"))
                            ];
                        case 1:
                            data = _state.sent();
                            dataArr = Array.from(data);
                            incomingLocation = (ref = dataArr.filter(function(item) {
                                return item.value === cookieCatalogRegion.toUpperCase();
                            })) === null || ref === void 0 ? void 0 : ref[0];
                            // @ts-ignore
                            setLocation(incomingLocation ? incomingLocation.name : "Espa\xf1a");
                            return [
                                2
                            ];
                    }
                });
            });
            return _getCurrentLocation.apply(this, arguments);
        }
        if (location) return;
        else if (utils.getStoreByLocale[locale]) {
            var store = utils.getStoreByLocale[locale];
            setLocation(store);
        } else if (!cookieCatalogRegion) {
            var store1 = utils.getStoreByLocale[locale];
            setLocation(store1 !== null && store1 !== void 0 ? store1 : "Espa\xf1a");
            return;
        } else getCurrentLocation();
    }, [
        location,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RssSection, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "stamp",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                            media: mediaStamp
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                            media: ecoStamp
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Figure, {
                            media: mozzarellaStamp
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row-partners",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                t("layout.footer.partners")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: FeaturedLogos
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row-copyright",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                "\xa9 Mammafiore ",
                                new Date().getFullYear()
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Link, {
                            href: FOOTER_URLS[localeRegion] || "/",
                            children: t("layout.footer.legal_warning")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "list--rrss",
                    children: ListItemsSocialLinks
                }),
                locale !== "en-EU" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DivChangeRegion, {
                    children: [
                        location && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                t("modals.comercial_region.you_are_in"),
                                location
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components.Button, {
                            onClick: toggle,
                            className: "btn--country-and-lang",
                            outline: true,
                            bgType: "white",
                            children: t("layout.footer.change_country_lang")
                        })
                    ]
                })
            ]
        })
    });
}));
var RssSection = styled_components_browser_esm["default"].section.withConfig({
    displayName: "SectionRrss__RssSection",
    componentId: "sc-5f2ed4d7-0"
})(_templateObject(), (0,styles.designGrid)({}), styles.mq.greaterThan("tablet"), styles.mq.greaterThan("tablet"), (0,styles.vw)(10, "mobile"), (0,styles.vw)(100, "mobile"), (0,styles.vw)(75, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), (0,styles.vw)(100, "nexus7"), (0,styles.vw)(100, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(100, "desktop"), (0,styles.vw)(100, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.colors.creme;
}, (0,styles.vw)(10, "mobile"), (0,styles.vw)(75, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(10, "nexus7"), (0,styles.vw)(100, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(15, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(15, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(30, "mobile"), (0,styles.vw)(30, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(30, "nexus7"), (0,styles.vw)(30, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.vw)(60, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(60, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(60, "desktop"), styles.mq.greaterThan("desktop"), (0,styles.getP15_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, (0,styles.vw)(5, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(5, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(30, "desktop"), styles.mq.greaterThan("desktop"), function(param) {
    var theme = param.theme;
    return theme.ease;
}, (0,styles.getP15_3)(), (0,styles.vw)(90, "mobile"), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, (0,styles.vw)(50, "mobile"), function(param) {
    var theme = param.theme;
    return theme.fonts.secondaryFont;
}, (0,styles.vw)(20, "mobile"), styles.mq.greaterThan("nexus7"), (0,styles.vw)(50, "nexus7"), (0,styles.vw)(50, "nexus7"), (0,styles.vw)(20, "nexus7"), styles.mq.greaterThan("tablet"), (0,styles.vw)(90, "desktop"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(20, "desktop"), styles.mq.greaterThan("desktop"), styles.mq.lessThan("tablet"), (0,styles.vw)(25, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.getP15_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.darkred;
}, (0,styles.vw)(30, "mobile"), (0,styles.vw)(10, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(25, "desktop"), (0,styles.vw)(50, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), (0,styles.vw)(50, "mobile"), function(param) {
    var theme = param.theme;
    return theme.colors.creme;
}, (0,styles.vw)(20, "mobile"), (0,styles.vw)(90, "mobile"), styles.mq.greaterThan("tablet"), (0,styles.vw)(50, "desktop"), (0,styles.vw)(40, "desktop"), (0,styles.vw)(130, "desktop"));
var DivChangeRegion = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SectionRrss__DivChangeRegion",
    componentId: "sc-5f2ed4d7-1"
})(_templateObject1(), styles.mq.greaterThan("tablet"), (0,styles.getP15_1)(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, styles.mq.greaterThan("tablet"), styles.mq.greaterThan("desktop-xs"));


/***/ })

}]);